export function portfoliosUrl(): string {
  return '/api/portfolios/';
}

export function portfolioOrgMembersUrl(
  portfolioId: number,
  orgId: number
): string {
  return `/api/portfolios/${portfolioId}/orgs/${orgId}/members/`;
}

export function portfolioOrgTeamsUrl(
  portfolioId: number,
  orgId: number
): string {
  return `/api/portfolios/${portfolioId}/orgs/${orgId}/teams/`;
}

export function portfolioSetMemberRoleUrl(
  portfolioId: number,
  orgId: number,
  userId: number
): string {
  return `/api/portfolios/${portfolioId}/orgs/${orgId}/members/${userId}/set-role/`;
}

export function portfolioMemberTeamsUrl(
  portfolioId: number,
  orgId: number,
  userId: number
): string {
  return `/api/portfolios/${portfolioId}/orgs/${orgId}/members/${userId}/teams/`;
}

export function portfolioMemberTeamUrl(
  portfolioId: number,
  orgId: number,
  userId: number,
  teamEntityId: string
): string {
  return `/api/portfolios/${portfolioId}/orgs/${orgId}/members/${userId}/teams/${teamEntityId}/`;
}

export function portfolioOrgInvitationsUrl(
  portfolioId: number,
  orgId: number
): string {
  return `/api/portfolios/${portfolioId}/orgs/${orgId}/invitations/`;
}

export function portfolioInvitationUrl(
  portfolioId: number,
  orgId: number,
  invitationId: string
): string {
  return `/api/portfolios/${portfolioId}/orgs/${orgId}/invitations/${invitationId}/`;
}

export function portfolioResendInvitationUrl(
  portfolioId: number,
  orgId: number,
  invitationId: string
): string {
  return `/api/portfolios/${portfolioId}/orgs/${orgId}/invitations/${invitationId}/resend/`;
}

export function portfolioSnowflakeCreateUrl(
  portfolioId: number,
  orgId: number
): string {
  return `/api/portfolios/${portfolioId}/orgs/${orgId}/snowflake/requests/`;
}

export function orgSnowflakeRequestsUrl(orgId: number): string {
  return `/api/portfolios/orgs/${orgId}/snowflake/requests/`;
}

export function orgSnowflakeApproveUrl(
  orgId: number,
  requestId: number
): string {
  return `/api/portfolios/orgs/${orgId}/snowflake/requests/${requestId}/approve/`;
}

export function orgSnowflakeDeclineUrl(
  orgId: number,
  requestId: number
): string {
  return `/api/portfolios/orgs/${orgId}/snowflake/requests/${requestId}/decline/`;
}

export function orgSnowflakeConnectionUrl(orgId: number): string {
  return `/api/portfolios/orgs/${orgId}/snowflake/connection/`;
}

export function portfolioSnowflakeCredentialsUrl(portfolioId: number): string {
  return `/api/portfolios/${portfolioId}/snowflake/credentials/`;
}

export function orgSnowflakeStatusesUrl(portfolioId: number): string {
  return `/api/portfolios/${portfolioId}/snowflake/status/`;
}

export function portfolioSnowflakeCredentialRevokeUrl(
  portfolioId: number,
  credentialId: number
): string {
  return `/api/portfolios/${portfolioId}/snowflake/credentials/${credentialId}/revoke/`;
}

export const portfolioQueryKeys = {
  list: (userId: number | undefined) => ['portfolio', 'list', userId] as const,
  orgMembers: (portfolioId: number, orgId: number) =>
    ['portfolio', portfolioId, 'org', orgId, 'members'] as const,
  orgTeams: (portfolioId: number, orgId: number) =>
    ['portfolio', portfolioId, 'org', orgId, 'teams'] as const,
  orgInvitations: (portfolioId: number, orgId: number) =>
    ['portfolio', portfolioId, 'org', orgId, 'invitations'] as const,
  orgSnowflakeRequests: (orgId: number) =>
    ['portfolio', 'org', orgId, 'snowflake-requests'] as const,
  orgSnowflakeConnection: (orgId: number) =>
    ['portfolio', 'org', orgId, 'snowflake-connection'] as const,
  snowflakeCredentials: (portfolioId: number) =>
    ['portfolio', portfolioId, 'snowflake-credentials'] as const,
  orgSnowflakeStatuses: (portfolioId: number) =>
    ['portfolio', portfolioId, 'snowflake-statuses'] as const,
};
